import { render, staticRenderFns } from "./NotificationContactForm.vue?vue&type=template&id=7b2d1e08&scoped=true&"
import script from "./NotificationContactForm.vue?vue&type=script&lang=ts&"
export * from "./NotificationContactForm.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationContactForm.vue?vue&type=style&index=0&id=7b2d1e08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2d1e08",
  null
  
)

export default component.exports